import React from "react";
import Report from "../pages/Report/Report";
import StudentTable from "../pages/Leads/Student";
import StudentPayment from "../pages/StudentPayment/StudentPayment";
const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const AdminRoutes = [
    { path: "/dashboard", name: "Dashboard", element: Dashboard, exact: true },
    { path: "/student", name: "Dashboard", element: StudentTable, exact: true },
    { path: "/resport", name: "Dashboard", element: Report, exact: true },
    { path: "/student-payments", name: "Dashboard", element: StudentPayment, exact: true },

];

export default AdminRoutes;

